import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import '../style/style.css';
import PropTypes from 'prop-types';
import updateAbout from '../services/About';
import SuccessMessage from './SuccessMessage';

/* eslint no-underscore-dangle: 0 */

export default function AboutEdit({ About }) {
  const [show, setShow] = useState(false);
  const [aboutPt, setAboutPt] = useState(About.text.pt);
  const [aboutEs, setAboutEs] = useState(About.text.es);

  let succeed = true;

  const editAbout = async (e) => {
    e.preventDefault();
    const formAboutPt = document.getElementById('about-text-pt');
    const formAboutEs = document.getElementById('about-text-es');
    succeed = true;

    if (
      (formAboutEs.value === aboutEs)
      && (formAboutPt.value === aboutPt)
    ) return;

    await updateAbout(About._id, formAboutPt.value, formAboutEs.value)
      .catch((err) => {
        succeed = false;
        document.getElementById(About._id).textContent = err.response.data.message;
      })
      .then(() => {
        if (succeed) {
          setAboutPt(formAboutPt.value);
          setAboutEs(formAboutEs.value);
          document.getElementById(About._id).textContent = null;
          setShow(true);
        }
      });
  };

  const reset = async (e) => {
    e.preventDefault();
    const formAboutPt = document.getElementById('about-text-pt');
    const formAboutEs = document.getElementById('about-text-es');

    formAboutEs.value = aboutEs;
    formAboutPt.value = aboutPt;

    document.getElementById(About._id).textContent = null;
  };

  return (
    <div id="editar-sobre" className="about-edit">
      <p className="title mb-1">Editar Sobre Nós</p>
      <hr className="edit-divider" />
      <Card>
        <Card.Header as="h5">Português</Card.Header>
        <Form.Control
          className="about-text"
          as="textarea"
          id="about-text-pt"
          rows={6}
          style={{ resize: 'none', whiteSpace: 'pre' }}
          defaultValue={About.text.pt}
        />
      </Card>
      <Card className="mt-1">
        <Card.Header as="h5">Espanhol</Card.Header>
        <Form.Control
          className="about-text"
          as="textarea"
          id="about-text-es"
          rows={6}
          style={{ resize: 'none' }}
          defaultValue={About.text.es}
        />
        <div>
          <small id={About._id} className="text-danger pre-wrap">
            {' '}
          </small>
        </div>
        <div className="edit-about-buttons d-flex justify-content-md-start justify-content-center">
          <Button onClick={(e) => editAbout(e)} variant="principal btn-custom">
            Guardar alterações
          </Button>
          <Button onClick={(e) => reset(e)} variant="cancel btn-custom">
            Cancelar
          </Button>
        </div>
      </Card>
      <SuccessMessage
        show={show}
        setShow={setShow}
        message="A secção 'Sobre Nós' foi editada com sucesso!"
      />
    </div>
  );
}

AboutEdit.propTypes = {
  About: PropTypes.instanceOf(Object).isRequired,
};
